import { MESSAGE } from '@repo/constants'

export class CsvValidationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'CsvValidationError'
  }
}

// Hono clients throw either the JSON error body or an Error built from it —
// in both shapes the backend MESSAGE.* code (or server message) is `message`.
//
// VALIDATION_ERROR resolves to the caller's fallback: it is the one code every
// validated route can answer, and the caller's fallback is already translated
// where the code is not. Callers that want to name the offending field read
// the response's `issues` array.
export function getErrorMessage(error: unknown, fallback: string): string {
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message !== MESSAGE.VALIDATION_ERROR
  ) {
    return error.message
  }
  return fallback
}

// The rate limiter answers 429 with prose, not a `MESSAGE.*` code — deliberately,
// because a dozen render sites across the apps print the body's `message`
// verbatim and a code there would reach users as the literal string. So a
// display site that wants its own copy branches on the STATUS, which every error
// shape carries: the driver portal throws the raw error body (`{ message, status }`
// from the backend's error handler) and the mobile app throws an `ApiError` with
// a `status` field.
export function isRateLimited(error: unknown): boolean {
  return error !== null && typeof error === 'object' && 'status' in error && error.status === 429
}

export function formatError(error: unknown) {
  if (error instanceof Error) {
    return { message: error.message, stack: error.stack || 'No stack trace available' }
  }

  return {
    message: typeof error === 'string' ? error : 'An unknown error occurred',
    stack: 'No stack trace available',
  }
}
